// ล้างสถานะระหว่าง render ไม่ใช้ useEffect([playerKey]) — effect ของ player ลูกที่แจ้ง onConnecting
// ตอน mount รันก่อนของพ่อ แล้ว reset ของพ่อจะมาทับ

import { useCallback, useEffect, useRef, useState } from 'react'
import { PLAYER } from './cellState'

function blank(key) {
  return {
    key,
    player: PLAYER.IDLE,
    error: null,
    speed: null,
    timedOut: false,
  }
}

export default function usePlayerStatus(playerKey) {
  const [state, setState] = useState(() => blank(playerKey))

  // setState ระหว่าง render — React รันซ้ำทันทีก่อน commit · ต้องล้างแม้เปลี่ยนกลับเป็น key เดิม
  // (สลับโหมดไปกลับแล้ว join stream เดิม) ไม่งั้น player ใหม่ได้ PLAYING ของตัวเก่า
  if (state.key !== playerKey) setState(blank(playerKey))

  const keyRef = useRef(playerKey)
  keyRef.current = playerKey

  // กรอบถูกถอดแล้ว (ปิดกรอบระหว่างขอ URL ใหม่ ฯลฯ) — ไม่มี player ตัวไหน "ปัจจุบัน" อีก
  const mounted = useRef(true)
  useEffect(
    () => () => {
      mounted.current = false
    },
    [],
  )

  const isCurrent = useCallback(
    key => mounted.current && key === keyRef.current,
    [],
  )

  // patch = object หรือ fn(สถานะปัจจุบัน) ที่คืน object · คืน null = ไม่เปลี่ยน
  const writerFor = useCallback(
    key => patch => {
      if (!mounted.current) return
      setState(prev => {
        if (key !== keyRef.current) return prev // player ตัวเก่า — ทิ้ง
        const base = prev.key === key ? prev : blank(key)
        const next = typeof patch === 'function' ? patch(base) : patch
        return next ? { ...base, ...next } : prev
      })
    },
    [],
  )

  const status = state.key === playerKey ? state : blank(playerKey)
  return { status, writerFor, isCurrent }
}
